module.exports = __webpack_public_path__ + "static/img/level2_two_img.424e9d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20240117/level2_two_img.png
// module id = mUmI
// module chunks = 0